// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ConversationCloseRequestDatagramBuf } from '../request/conversation-close-request-datagram-buf.js';
import { ConversationCreateRequestDatagramBuf } from '../request/conversation-create-request-datagram-buf.js';
import { ConversationDeleteRequestDatagramBuf } from '../request/conversation-delete-request-datagram-buf.js';
import { ConversationPropertiesRequestDatagramBuf } from '../request/conversation-properties-request-datagram-buf.js';
import { ConversationSubscribeRequestDatagramBuf } from '../request/conversation-subscribe-request-datagram-buf.js';
import { ConversationTurnRequestDatagramBuf } from '../request/conversation-turn-request-datagram-buf.js';
import { ConversationUpdateRequestDatagramBuf } from '../request/conversation-update-request-datagram-buf.js';
import { FileCopyRequestDatagramBuf } from '../request/file-copy-request-datagram-buf.js';
import { FileCreateRequestDatagramBuf } from '../request/file-create-request-datagram-buf.js';
import { FileDeleteRequestDatagramBuf } from '../request/file-delete-request-datagram-buf.js';
import { FileDownloadRequestDatagramBuf } from '../request/file-download-request-datagram-buf.js';
import { FileEditRequestDatagramBuf } from '../request/file-edit-request-datagram-buf.js';
import { FileFindRequestDatagramBuf } from '../request/file-find-request-datagram-buf.js';
import { FileHistoryRequestDatagramBuf } from '../request/file-history-request-datagram-buf.js';
import { FileMoveRequestDatagramBuf } from '../request/file-move-request-datagram-buf.js';
import { FilePrepareRequestDatagramBuf } from '../request/file-prepare-request-datagram-buf.js';
import { FilePropertiesRequestDatagramBuf } from '../request/file-properties-request-datagram-buf.js';
import { FileRevisionRequestDatagramBuf } from '../request/file-revision-request-datagram-buf.js';
import { FileRootHistoryRequestDatagramBuf } from '../request/file-root-history-request-datagram-buf.js';
import { FileShareRequestDatagramBuf } from '../request/file-share-request-datagram-buf.js';
import { FileUpdateRequestDatagramBuf } from '../request/file-update-request-datagram-buf.js';
import { FilesSharedWithSelfRequestDatagramBuf } from '../request/files-shared-with-self-request-datagram-buf.js';
import { FolderContentHistoryRequestDatagramBuf } from '../request/folder-content-history-request-datagram-buf.js';
import { FolderListRequestDatagramBuf } from '../request/folder-list-request-datagram-buf.js';
import { FolderSubscribeRequestDatagramBuf } from '../request/folder-subscribe-request-datagram-buf.js';
import { SearchAutocompleteRequestDatagramBuf } from '../request/search-autocomplete-request-datagram-buf.js';
import { SearchListRequestDatagramBuf } from '../request/search-list-request-datagram-buf.js';
import { SearchPropertiesRequestDatagramBuf } from '../request/search-properties-request-datagram-buf.js';
import { SearchUpdateRequestDatagramBuf } from '../request/search-update-request-datagram-buf.js';
import { SelfConversationsRequestDatagramBuf } from '../request/self-conversations-request-datagram-buf.js';
import { SelfInfoRequestDatagramBuf } from '../request/self-info-request-datagram-buf.js';
import { SelfSharedFoldersRequestDatagramBuf } from '../request/self-shared-folders-request-datagram-buf.js';
import { SelfSidebarRequestDatagramBuf } from '../request/self-sidebar-request-datagram-buf.js';
import { SelfUpdateRequestDatagramBuf } from '../request/self-update-request-datagram-buf.js';
import { SharedFolderCreateRequestDatagramBuf } from '../request/shared-folder-create-request-datagram-buf.js';
import { SharedFolderDeleteRequestDatagramBuf } from '../request/shared-folder-delete-request-datagram-buf.js';
import { SharedFolderFindRequestDatagramBuf } from '../request/shared-folder-find-request-datagram-buf.js';
import { SharedFolderMembershipRequestDatagramBuf } from '../request/shared-folder-membership-request-datagram-buf.js';
import { UserFindRequestDatagramBuf } from '../request/user-find-request-datagram-buf.js';
import { UserThumbnailRequestDatagramBuf } from '../request/user-thumbnail-request-datagram-buf.js';


export class RequestDatagramBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):RequestDatagramBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsRequestDatagramBuf(bb:flatbuffers.ByteBuffer, obj?:RequestDatagramBuf):RequestDatagramBuf {
  return (obj || new RequestDatagramBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsRequestDatagramBuf(bb:flatbuffers.ByteBuffer, obj?:RequestDatagramBuf):RequestDatagramBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new RequestDatagramBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

conversationCreateRequest(obj?:ConversationCreateRequestDatagramBuf):ConversationCreateRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new ConversationCreateRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationCloseRequest(obj?:ConversationCloseRequestDatagramBuf):ConversationCloseRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new ConversationCloseRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationSubscribeRequest(obj?:ConversationSubscribeRequestDatagramBuf):ConversationSubscribeRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new ConversationSubscribeRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationTurnRequest(obj?:ConversationTurnRequestDatagramBuf):ConversationTurnRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new ConversationTurnRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileCopyRequest(obj?:FileCopyRequestDatagramBuf):FileCopyRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new FileCopyRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileCreateRequest(obj?:FileCreateRequestDatagramBuf):FileCreateRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new FileCreateRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileDeleteRequest(obj?:FileDeleteRequestDatagramBuf):FileDeleteRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? (obj || new FileDeleteRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileDownloadRequest(obj?:FileDownloadRequestDatagramBuf):FileDownloadRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? (obj || new FileDownloadRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileEditRequest(obj?:FileEditRequestDatagramBuf):FileEditRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? (obj || new FileEditRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileHistoryRequest(obj?:FileHistoryRequestDatagramBuf):FileHistoryRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? (obj || new FileHistoryRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileMoveRequest(obj?:FileMoveRequestDatagramBuf):FileMoveRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? (obj || new FileMoveRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

filePrepareRequest(obj?:FilePrepareRequestDatagramBuf):FilePrepareRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? (obj || new FilePrepareRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

filePropertiesRequest(obj?:FilePropertiesRequestDatagramBuf):FilePropertiesRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? (obj || new FilePropertiesRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileShareRequest(obj?:FileShareRequestDatagramBuf):FileShareRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 30);
  return offset ? (obj || new FileShareRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileUpdateRequest(obj?:FileUpdateRequestDatagramBuf):FileUpdateRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 32);
  return offset ? (obj || new FileUpdateRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

searchAutocompleteRequest(obj?:SearchAutocompleteRequestDatagramBuf):SearchAutocompleteRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 34);
  return offset ? (obj || new SearchAutocompleteRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

filesSharedWithSelfRequest(obj?:FilesSharedWithSelfRequestDatagramBuf):FilesSharedWithSelfRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 36);
  return offset ? (obj || new FilesSharedWithSelfRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

folderContentHistoryRequest(obj?:FolderContentHistoryRequestDatagramBuf):FolderContentHistoryRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 38);
  return offset ? (obj || new FolderContentHistoryRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

folderListRequest(obj?:FolderListRequestDatagramBuf):FolderListRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 40);
  return offset ? (obj || new FolderListRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

folderSubscribeRequest(obj?:FolderSubscribeRequestDatagramBuf):FolderSubscribeRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 42);
  return offset ? (obj || new FolderSubscribeRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

selfConversationsRequest(obj?:SelfConversationsRequestDatagramBuf):SelfConversationsRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 44);
  return offset ? (obj || new SelfConversationsRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

selfInfoRequest(obj?:SelfInfoRequestDatagramBuf):SelfInfoRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 46);
  return offset ? (obj || new SelfInfoRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

selfSharedFoldersRequest(obj?:SelfSharedFoldersRequestDatagramBuf):SelfSharedFoldersRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 48);
  return offset ? (obj || new SelfSharedFoldersRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

selfSidebarRequest(obj?:SelfSidebarRequestDatagramBuf):SelfSidebarRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 50);
  return offset ? (obj || new SelfSidebarRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

selfUpdateRequest(obj?:SelfUpdateRequestDatagramBuf):SelfUpdateRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 52);
  return offset ? (obj || new SelfUpdateRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

sharedFolderCreateRequest(obj?:SharedFolderCreateRequestDatagramBuf):SharedFolderCreateRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 54);
  return offset ? (obj || new SharedFolderCreateRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

sharedFolderDeleteRequest(obj?:SharedFolderDeleteRequestDatagramBuf):SharedFolderDeleteRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 56);
  return offset ? (obj || new SharedFolderDeleteRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

sharedFolderFindRequest(obj?:SharedFolderFindRequestDatagramBuf):SharedFolderFindRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 58);
  return offset ? (obj || new SharedFolderFindRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

sharedFolderMembershipRequest(obj?:SharedFolderMembershipRequestDatagramBuf):SharedFolderMembershipRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 60);
  return offset ? (obj || new SharedFolderMembershipRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

userFindRequest(obj?:UserFindRequestDatagramBuf):UserFindRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 62);
  return offset ? (obj || new UserFindRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

userThumbnailRequest(obj?:UserThumbnailRequestDatagramBuf):UserThumbnailRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 64);
  return offset ? (obj || new UserThumbnailRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

searchListRequest(obj?:SearchListRequestDatagramBuf):SearchListRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 66);
  return offset ? (obj || new SearchListRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileRootHistoryRequest(obj?:FileRootHistoryRequestDatagramBuf):FileRootHistoryRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 68);
  return offset ? (obj || new FileRootHistoryRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationPropertiesRequest(obj?:ConversationPropertiesRequestDatagramBuf):ConversationPropertiesRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 70);
  return offset ? (obj || new ConversationPropertiesRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

searchUpdateRequest(obj?:SearchUpdateRequestDatagramBuf):SearchUpdateRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 72);
  return offset ? (obj || new SearchUpdateRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileFindRequest(obj?:FileFindRequestDatagramBuf):FileFindRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 74);
  return offset ? (obj || new FileFindRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileRevisionRequest(obj?:FileRevisionRequestDatagramBuf):FileRevisionRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 76);
  return offset ? (obj || new FileRevisionRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationUpdateRequest(obj?:ConversationUpdateRequestDatagramBuf):ConversationUpdateRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 78);
  return offset ? (obj || new ConversationUpdateRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationDeleteRequest(obj?:ConversationDeleteRequestDatagramBuf):ConversationDeleteRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 80);
  return offset ? (obj || new ConversationDeleteRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

searchPropertiesRequest(obj?:SearchPropertiesRequestDatagramBuf):SearchPropertiesRequestDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 82);
  return offset ? (obj || new SearchPropertiesRequestDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startRequestDatagramBuf(builder:flatbuffers.Builder) {
  builder.startObject(40);
}

static addConversationCreateRequest(builder:flatbuffers.Builder, conversationCreateRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, conversationCreateRequestOffset, 0);
}

static addConversationCloseRequest(builder:flatbuffers.Builder, conversationCloseRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, conversationCloseRequestOffset, 0);
}

static addConversationSubscribeRequest(builder:flatbuffers.Builder, conversationSubscribeRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, conversationSubscribeRequestOffset, 0);
}

static addConversationTurnRequest(builder:flatbuffers.Builder, conversationTurnRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, conversationTurnRequestOffset, 0);
}

static addFileCopyRequest(builder:flatbuffers.Builder, fileCopyRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, fileCopyRequestOffset, 0);
}

static addFileCreateRequest(builder:flatbuffers.Builder, fileCreateRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, fileCreateRequestOffset, 0);
}

static addFileDeleteRequest(builder:flatbuffers.Builder, fileDeleteRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, fileDeleteRequestOffset, 0);
}

static addFileDownloadRequest(builder:flatbuffers.Builder, fileDownloadRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(7, fileDownloadRequestOffset, 0);
}

static addFileEditRequest(builder:flatbuffers.Builder, fileEditRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(8, fileEditRequestOffset, 0);
}

static addFileHistoryRequest(builder:flatbuffers.Builder, fileHistoryRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(9, fileHistoryRequestOffset, 0);
}

static addFileMoveRequest(builder:flatbuffers.Builder, fileMoveRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(10, fileMoveRequestOffset, 0);
}

static addFilePrepareRequest(builder:flatbuffers.Builder, filePrepareRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(11, filePrepareRequestOffset, 0);
}

static addFilePropertiesRequest(builder:flatbuffers.Builder, filePropertiesRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(12, filePropertiesRequestOffset, 0);
}

static addFileShareRequest(builder:flatbuffers.Builder, fileShareRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(13, fileShareRequestOffset, 0);
}

static addFileUpdateRequest(builder:flatbuffers.Builder, fileUpdateRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(14, fileUpdateRequestOffset, 0);
}

static addSearchAutocompleteRequest(builder:flatbuffers.Builder, searchAutocompleteRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(15, searchAutocompleteRequestOffset, 0);
}

static addFilesSharedWithSelfRequest(builder:flatbuffers.Builder, filesSharedWithSelfRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(16, filesSharedWithSelfRequestOffset, 0);
}

static addFolderContentHistoryRequest(builder:flatbuffers.Builder, folderContentHistoryRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(17, folderContentHistoryRequestOffset, 0);
}

static addFolderListRequest(builder:flatbuffers.Builder, folderListRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(18, folderListRequestOffset, 0);
}

static addFolderSubscribeRequest(builder:flatbuffers.Builder, folderSubscribeRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(19, folderSubscribeRequestOffset, 0);
}

static addSelfConversationsRequest(builder:flatbuffers.Builder, selfConversationsRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(20, selfConversationsRequestOffset, 0);
}

static addSelfInfoRequest(builder:flatbuffers.Builder, selfInfoRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(21, selfInfoRequestOffset, 0);
}

static addSelfSharedFoldersRequest(builder:flatbuffers.Builder, selfSharedFoldersRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(22, selfSharedFoldersRequestOffset, 0);
}

static addSelfSidebarRequest(builder:flatbuffers.Builder, selfSidebarRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(23, selfSidebarRequestOffset, 0);
}

static addSelfUpdateRequest(builder:flatbuffers.Builder, selfUpdateRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(24, selfUpdateRequestOffset, 0);
}

static addSharedFolderCreateRequest(builder:flatbuffers.Builder, sharedFolderCreateRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(25, sharedFolderCreateRequestOffset, 0);
}

static addSharedFolderDeleteRequest(builder:flatbuffers.Builder, sharedFolderDeleteRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(26, sharedFolderDeleteRequestOffset, 0);
}

static addSharedFolderFindRequest(builder:flatbuffers.Builder, sharedFolderFindRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(27, sharedFolderFindRequestOffset, 0);
}

static addSharedFolderMembershipRequest(builder:flatbuffers.Builder, sharedFolderMembershipRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(28, sharedFolderMembershipRequestOffset, 0);
}

static addUserFindRequest(builder:flatbuffers.Builder, userFindRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(29, userFindRequestOffset, 0);
}

static addUserThumbnailRequest(builder:flatbuffers.Builder, userThumbnailRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(30, userThumbnailRequestOffset, 0);
}

static addSearchListRequest(builder:flatbuffers.Builder, searchListRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(31, searchListRequestOffset, 0);
}

static addFileRootHistoryRequest(builder:flatbuffers.Builder, fileRootHistoryRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(32, fileRootHistoryRequestOffset, 0);
}

static addConversationPropertiesRequest(builder:flatbuffers.Builder, conversationPropertiesRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(33, conversationPropertiesRequestOffset, 0);
}

static addSearchUpdateRequest(builder:flatbuffers.Builder, searchUpdateRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(34, searchUpdateRequestOffset, 0);
}

static addFileFindRequest(builder:flatbuffers.Builder, fileFindRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(35, fileFindRequestOffset, 0);
}

static addFileRevisionRequest(builder:flatbuffers.Builder, fileRevisionRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(36, fileRevisionRequestOffset, 0);
}

static addConversationUpdateRequest(builder:flatbuffers.Builder, conversationUpdateRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(37, conversationUpdateRequestOffset, 0);
}

static addConversationDeleteRequest(builder:flatbuffers.Builder, conversationDeleteRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(38, conversationDeleteRequestOffset, 0);
}

static addSearchPropertiesRequest(builder:flatbuffers.Builder, searchPropertiesRequestOffset:flatbuffers.Offset) {
  builder.addFieldOffset(39, searchPropertiesRequestOffset, 0);
}

static endRequestDatagramBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

}
